// extracted by mini-css-extract-plugin
export var gridContainer = "BackgroundImage-module--gridContainer--GygOC";
export var imageStyle = "BackgroundImage-module--imageStyle--zli2t";
export var content = "BackgroundImage-module--content--IY-QK";